import HomePage from "@/modules/landing/pages/HomePage";
import ViaVerdePage from "@/modules/landing/pages/ViaVerdePage";
import AllinvestPage from "@/modules/landing/pages/AllinvestPage";
import ConsorcioPage from "@/modules/landing/pages/ConsorcioPage";
import QuienesSomosPage from "@/modules/landing/pages/QuienesSomosPage";

export default {
  path: '/',
  children: [
    {
      path: '',
      name: 'home',
      component: HomePage,
       meta: { countViews: true }
    },
    {
      path: 'viaverde',
      name: 'viaverde',
      component: ViaVerdePage,
       meta: { countViews: true }
    },
    {
      path: 'al-invest-verde',
      name: 'alinvest',
      component: AllinvestPage,
       meta: { countViews: true }
    },
    {
      path: 'consorcio',
      name: 'consorcio',
      component: ConsorcioPage,
       meta: { countViews: true }
    },
    {
      path: 'quienes-somos',
      name: 'quienes-somos',
      component: QuienesSomosPage,
       meta: { countViews: true }
    },
  ],
};
